import * as React from 'react'
import * as Styles from './FloatCodeStyle'

interface IFloatCodeState {
    title: string,
    subtitle: string,
    subscribedQrcode: string,
    content?: string
    hideFloatWindow: () => void | null
}

export default class FloatCode extends React.Component <IFloatCodeState> {
    public render() {
        return (
            <div className={Styles.FloatCodeBox} style={{height: window.innerHeight}}>
                <div className={Styles.FloatCodeMask} onClick={this.props.hideFloatWindow}/>

                <div className={Styles.FloatCodeContainer}>

                    <div className={Styles.FloatCodeTitle}>{this.props.title}</div>

                    <div className={Styles.FloatCodeSubtitle}>{this.props.subtitle}</div>

                    <div className={Styles.FloatCodeImgBox}>
                        <img className={Styles.FloatCodeImgBoxImg} src={this.props.subscribedQrcode} />
                    </div>

                    {this.props.content ?
                        <div className={Styles.FloatCodeContent}>
                            {this.props.content}
                        </div> : null}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/FreeLecture/components/FloatCode/FloatCode.tsx